import _implicitStylesheets from "./input.css";
import _implicitScopedStylesheets from "./input.scoped.css?scoped=true";
import _c360Icon from "c360/icon";
import _pricingTooltip from "pricing/tooltip";
import {freezeTemplate, parseFragment, registerTemplate} from "lwc";
const $fragment1 = parseFragment`<div${"c0"}${2}>${"t1"}</div>`;
const $fragment2 = parseFragment`<div class="slds-badge slds-m-left_medium${0}" data-test-id="badge"${2}>${"t1"}</div>`;
const $fragment3 = parseFragment`<div class="overview${0}"${2}>${"t1"}</div>`;
const $fragment4 = parseFragment`<input${"a0:name"}${"a0:type"}${"a0:maxlength"}${"a0:minlength"}${"a0:placeholder"}${"c0"}${"a0:required"}${"a0:disabled"}${"a0:aria-label"}${"a0:data-id"}${"a0:data-type"}${2}>`;
const $fragment5 = parseFragment`<span${3}>${"t1"}</span>`;
const $fragment6 = parseFragment`<span${3}>${"t1"}</span>`;
const $fragment7 = parseFragment`<span class="help-text${0}"${2}>${"t1"}</span>`;
const $fragment8 = parseFragment`<div${"c0"}${2}>${"t1"}</div>`;
const stc0 = {
  "label": true
};
const stc1 = {
  "tooltip": true,
  "tooltip-dnd": true,
  "slds-m-left_x-small": true
};
const stc2 = {
  classMap: {
    "tooltip-info": true
  },
  props: {
    "iconName": "utility:info",
    "size": "x-small"
  },
  key: 4
};
const stc3 = {
  attrs: {
    "name": "overview-content"
  },
  key: 9
};
const stc4 = [];
const stc5 = {
  classMap: {
    "slds-grid_align-spread": true
  },
  key: 12
};
const stc6 = {
  classMap: {
    "required-message": true
  },
  key: 13
};
function tmpl($api, $cmp, $slotset, $ctx) {
  const {gid: api_scoped_id, ncls: api_normalize_class_name, d: api_dynamic_text, sp: api_static_part, st: api_static_fragment, c: api_custom_element, h: api_element, s: api_slot, b: api_bind} = $api;
  const {_m0, _m1, _m2, _m3, _m4, _m5} = $ctx;
  return [$cmp.showLabel ? api_element("label", {
    classMap: stc0,
    attrs: {
      "id": api_scoped_id("inputLabel"),
      "type-style": $cmp.labelTypeStyle
    },
    key: 0
  }, [api_static_fragment($fragment1, 2, [api_static_part(0, {
    className: api_normalize_class_name($cmp.requiredCss)
  }, null), api_static_part(1, null, api_dynamic_text($cmp.label))]), $cmp.showTooltip ? api_custom_element("pricing-tooltip", _pricingTooltip, {
    classMap: stc1,
    props: {
      "tooltipTitle": $cmp.label,
      "content": $cmp.tooltipMessage,
      "nubbinPosition": "bottom-right",
      "positioning": "center"
    },
    key: 3
  }, [api_custom_element("c360-icon", _c360Icon, stc2)]) : null, $cmp.badge ? api_static_fragment($fragment2, 6, [api_static_part(1, null, api_dynamic_text($cmp.badge))]) : null]) : null, $cmp.overview ? api_static_fragment($fragment3, 8, [api_static_part(1, null, api_dynamic_text($cmp.overview))]) : null, api_slot("overview-content", stc3, stc4, $slotset), api_static_fragment($fragment4, 11, [api_static_part(0, {
    on: {
      "input": _m3 || ($ctx._m3 = api_bind($cmp.onChanged)),
      "focus": _m4 || ($ctx._m4 = api_bind($cmp.onFocus)),
      "blur": _m5 || ($ctx._m5 = api_bind($cmp.onBlur))
    },
    className: api_normalize_class_name($cmp.inputCss),
    attrs: {
      "name": $cmp.name,
      "type": $cmp.type,
      "maxlength": $cmp.maxLength,
      "minlength": $cmp.minLength,
      "placeholder": $cmp.placeholder,
      "required": $cmp.required ? "" : null,
      "disabled": $cmp.disabled ? "" : null,
      "aria-label": $cmp.label,
      "data-id": $cmp.identifier,
      "data-type": $cmp.typeData
    }
  }, null)]), api_element("div", stc5, [api_element("div", stc6, [$cmp.showRequiredError ? api_static_fragment($fragment5, 15, [api_static_part(1, null, api_dynamic_text($cmp.requiredText))]) : null, $cmp.showInvalidError ? api_static_fragment($fragment6, 17, [api_static_part(1, null, api_dynamic_text($cmp.invalidError))]) : null]), $cmp.showHelpInputMessage ? api_static_fragment($fragment7, 19, [api_static_part(1, null, api_dynamic_text($cmp.helpInputMessage))]) : null, $cmp.showRemainingCharactersInfo ? api_static_fragment($fragment8, 21, [api_static_part(0, {
    className: api_normalize_class_name($cmp.remainingCharactersCSS)
  }, null), api_static_part(1, null, api_dynamic_text($cmp.charactersRemainingDescription))]) : null])];
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.slots = ["overview-content"];
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-4oab9bt8stp";
tmpl.legacyStylesheetToken = "c360-input_input";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
